<template>
  <div class="index">
    <!-- 按照 Vue Router 官方建议的方式使用 router-view 和 keep-alive -->
    <router-view v-slot="{ Component }">
      <keep-alive :include="['Main']">
        <component :is="Component" />
      </keep-alive>
    </router-view>
  </div>
</template>

<script lang="ts">
import { mapGetters,mapMutations } from 'vuex'
export default {
  name: "App",
  data() {
    return {};
  },
  methods: {
    ...mapMutations(["commitBeforePath"])
  },
  computed: {
  // 使用对象展开运算符将 getter 混入 computed 对象中
    ...mapGetters([
      'getAccountgroupID',
      "getCampaignId",
      "getBeforePath"
    ])
  },
  mounted() {

  }
};
</script>

<style lang="less">
</style>
